
import axios from "../network/reuset"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const getApp = {
  getAdnList(params) {
    return axios.post(
      `/api/admin/adn/list`,
      qs.stringify(params)
    );
  },
  postAddAdn(params) {
    return axios.post(
      `/api/admin/adn/add`,
      qs.stringify(params)
    );
  },
  getAdnInfo(params) {
    return axios.post(
      `/api/admin/adn/info`,
      qs.stringify(params)
    );
  },
  postSaveAdnInfo(params) {
    return axios.post(
      `/api/admin/adn/save`,
      qs.stringify(params)
    );
  },
  delAdn(params) {
    return axios.post(
      `/api/admin/adn/del`,
      qs.stringify(params)
    );
  },
};
export default getApp;
